export default "__VITE_ASSET__sihRXwaD__"